import { render, staticRenderFns } from "./ListePointDeVente.vue?vue&type=template&id=dedcd4d4"
import script from "./ListePointDeVente.vue?vue&type=script&lang=js"
export * from "./ListePointDeVente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports